import BaseApi from './BaseApi'

class ClientTypesApi extends BaseApi {
  get clientTypesUrl () {
    return 'clientTypes'
  }

  fetchingClientTypes () {
    return this.getJson(this.clientTypesUrl)
  }
}
export default ClientTypesApi

